import React from "react";
import {ContactUsForm, PagesHero, SEO} from "../components";
const ContactUs = () => {
  return (
    <main>
      <SEO
        title="Contact Deep Kapadia | Frontend Developer for React, Next.js & UI Projects"
        description="Ready to start your next web project? Contact Deep Kapadia, an experienced frontend engineer specializing in React, Next.js, and Figma to HTML conversions. Let's build something exceptional together."
        keywords="Contact Deep Kapadia, React Developer India, Next.js Developer, Frontend Engineer, Web Developer Surat, Hire Web Developer, UI Developer, HTML CSS Expert"
        image="https://www.deepkapadia.work/images/preview.jpg"
        url="https://www.deepkapadia.work/contact-us"
      />

      <PagesHero
        subTitle="Let's Work Together"
        title="Contact Us"
        otherText1="Have a project in mind?"
        otherText2="Reach out and let’s make it happen."
        maskSubTitle="Start the Conversation"
        maskTitle="Write Me"
        maskOtherText1="Excited to build something great?"
        maskOtherText2="Let’s connect and discuss your idea."
      />
      <ContactUsForm />
    </main>
  );
};

export default ContactUs;
